import Event = createjs.Event;
import createjsSound = createjs.Sound;
import { getLogger } from "@goodgamestudios/logger";

const logger = getLogger("sound");

export class SoundService extends createjs.EventDispatcher {

    public static LOAD_DONE = "sound_load_done";
    public static LOAD_ERROR = "sound_load_error";
    public static AUDIO_SPRITE_DONE = "AudioSpritesDone";

    private static _instance: SoundService;

    public sounds: Map<string, createjs.EventDispatcher> = new Map();

    private _queue: createjs.LoadQueue | null = null;
    private _jsonUrl: string;
    private _audioSpriteInit = false;

    constructor() {
        super();
        if (SoundService._instance) {
            throw new Error("SoundService has no constructor, use SoundService.instance");
        }
        if (!createjsSound.isReady) {
            throw new Error("createjs.Sound not ready");
        }
        createjsSound.on("fileload", this.fileLoadHandler, this);
        createjsSound.on("fileerror", this.fileErrorHandler, this);
    }

    public static get instance() {
        return SoundService._instance || (SoundService._instance = new SoundService());
    }

    /**
     * Init function for audioSprite. Use
     * `SoundService.instance.addEventListener(SoundService.AUDIO_SPRITE_DONE)`
     * to check whether audiosprite initialization is finished.
     * @param jsonUrl audioSprite json url
     */
    public init(jsonUrl: string) {
        if (this._audioSpriteInit) { return; }
        this._audioSpriteInit = true;
        this._queue = new createjs.LoadQueue();
        this._jsonUrl = jsonUrl;
        this._queue.loadFile({
            id: "audiospritesJson",
            priority: 1,
            src: jsonUrl,
            type: createjs.AbstractLoader.JSON
        });
        this._queue.addEventListener("fileload", this._loadAudioSprites.bind(this));
        this._queue.addEventListener("error", (e) => {
            logger.error("error loading audiosprites.json by load queue from ", this._jsonUrl);
        });
    }

    private _loadAudioSprites() {
        if (!this._queue) {
            throw new Error(`_loadAudioSprites: this._queue is not set`);
        }

        let _json: any = this._queue.getResult("audiospritesJson");
        if (!_json) {
            throw new Error("Cannot load audio manifest");
        }
        _json.src = this._jsonUrl.replace(/.json$/i, ".mp3");
        this._queue = null;
        createjsSound.registerSounds([_json]);
    }

    private fileLoadHandler(event: Event) {
        if (!event.id) {
            this.dispatchEvent(SoundService.AUDIO_SPRITE_DONE);
        } else {
            const sound: createjs.EventDispatcher | undefined = SoundService.instance.sounds.get(event.id);
            if (sound) {
                sound.dispatchEvent(SoundService.LOAD_DONE);
                SoundService.instance.sounds.delete(event.id);
            }
        }
    }

    private fileErrorHandler(event: Event) {
        if (event.id) {
            const sound: createjs.EventDispatcher | undefined = SoundService.instance.sounds.get(event.id);
            if (sound) {
                sound.dispatchEvent(SoundService.LOAD_ERROR);
                SoundService.instance.sounds.delete(event.id);
            }
        }
        logger.error("error loading audiosprite", event);
    }
}
